/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetUserFeaturesResponse,
  CheckUserFeaturesRequest
} from './schema'



export const utxUserFeatureList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserFeaturesResponse>> => {
    return axios.get(
      `/user-features`,options
    );
  }


export const getUtxUserFeatureListQueryKey = () => [`/user-features`];

    
export type UtxUserFeatureListQueryResult = NonNullable<Awaited<ReturnType<typeof utxUserFeatureList>>>
export type UtxUserFeatureListQueryError = AxiosError<unknown>

export const useUtxUserFeatureList = <TData = Awaited<ReturnType<typeof utxUserFeatureList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUserFeatureList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUserFeatureListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUserFeatureList>>> = ({ signal }) => utxUserFeatureList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUserFeatureList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxUserFeatureCheckFeature = (
    checkUserFeaturesRequest: CheckUserFeaturesRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    return axios.post(
      `/user-features/check-features`,
      checkUserFeaturesRequest,options
    );
  }



    export type UtxUserFeatureCheckFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof utxUserFeatureCheckFeature>>>
    export type UtxUserFeatureCheckFeatureMutationBody = CheckUserFeaturesRequest
    export type UtxUserFeatureCheckFeatureMutationError = AxiosError<unknown>

    export const useUtxUserFeatureCheckFeature = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUserFeatureCheckFeature>>, TError,{data: CheckUserFeaturesRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUserFeatureCheckFeature>>, {data: CheckUserFeaturesRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUserFeatureCheckFeature(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUserFeatureCheckFeature>>, TError, {data: CheckUserFeaturesRequest}, TContext>(mutationFn, mutationOptions)
    }
    